import React from 'react';
import {useForm} from 'react-hook-form';
import {Button, Spinner} from 'react-bootstrap';

export const COMPANY_API_KEY_STATUS_OPTIONS = [
  {value: "", label: "All"},
  {value: "active", label: "Active"},
  {value: "revoked", label: "Revoked"},
  {value: "expired", label: "Expired"},
  {value: "inactive", label: "Inactive"},
];

function CompanyApiKeyFilter({totalCount, loading, companyOptions, resellerOptions, onResellerChange, onApply, onReset}) {
  const {register, handleSubmit, reset, setValue} = useForm();

  const handleResellerChange = (event) => {
    // companies depend on the reseller, so the previous company selection is no longer valid
    setValue("companyId", "");
    onResellerChange(event.target.value);
  }

  const handleResetSearch = () => {
    reset();
    onReset();
  }

  return (
    <form onSubmit={handleSubmit(onApply)} className="form form-label-right">
      <div className="font-weight-bold" style={{textAlign: 'right'}}>
        <h5>Total: {totalCount}</h5>
      </div>
      <br />
      <div className="form-group row">
        <div className="col-lg-2">
          <select
            className="form-control"
            name="resellerId"
            ref={register}
            onChange={handleResellerChange}
          >
            <option value="">All</option>
            {resellerOptions.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <small className="form-text text-muted">
            <b>Filter</b> by Reseller
          </small>
        </div>
        <div className="col-lg-2">
          <select
            className="form-control"
            name="companyId"
            ref={register}
          >
            <option value="">All</option>
            {companyOptions.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <small className="form-text text-muted">
            <b>Filter</b> by Company
          </small>
        </div>
        <div className="col-lg-2">
          <select
            className="form-control"
            name="status"
            ref={register}
          >
            {COMPANY_API_KEY_STATUS_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <small className="form-text text-muted">
            <b>Filter</b> by Status
          </small>
        </div>
        <div className="col-lg-3">
          <input
            type="text"
            ref={register}
            className="form-control"
            name="searchText"
            placeholder="Search"
          />
          <small className="form-text text-muted">
            <b>Search</b> by API Key
          </small>
        </div>
        <div className="col-lg-3">
          {
            loading && <Button variant="success" className={"mr-3"} disabled>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Searching...
            </Button>
          }
          {
            !loading && <button type="submit" className="btn btn-success mr-3">
              Search
            </button>
          }
          <button type="button" onClick={handleResetSearch} className="btn btn-warning">
            Reset
          </button>
        </div>
      </div>
    </form>
  );
}

CompanyApiKeyFilter.propTypes = {};
CompanyApiKeyFilter.defaultProps = {};

export default CompanyApiKeyFilter;
